export default "__VITE_ASSET__31997222__"